module.exports = __webpack_public_path__ + "img/smartby_logo_dark_menu.2c4ce75b.png";